/*
 * Module for the the content page, which shows an individual piece of web content
 */

define([
  "marionette",
  "messaging/messenger",
  "./contentTopicsView",
  "modules/shared/sortableList/sortableListModule",
  "./contentTopicsModel",
], function (Marionette, Messenger, ContentTopicsView, SortableListModule, ContentTopicsModel) {
  var ContentTopicsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "contentTopics";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (content) {
      this.topics = Messenger.reqres.request("content:topics", content.get("mappingId"));
      this.layout = new ContentTopicsView.contentTopicsLayout();

      var headers = Messenger.reqres.request("content:topics:headers");

      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.contentTopicsList,
          headers: headers,
          namespace: this.name,
          hideHeader: true,
          hideControls: true,
        }),
      );

      this.layout.on(
        "show",
        function () {
          this.list.show(this.topics);
        },
        this,
      );

      this.topics.onSynced(function () {
        this.showRegion(this.layout);
      }, this);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "contentTopics:selected:row",
        function (topic) {
          Messenger.vent.trigger("show:topic", topic);
        },
        this,
      );
    },
  });

  return ContentTopicsController;
});
